import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad299ebc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex flex-column justify-content-center" }
const _hoisted_2 = { class: "sw-app-footer--brand-container d-flex flex-column align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sw-app-footer--catch-copy order-1" }, "得意な工程で参加できるWEBTOONとマンガの投稿サイト", -1))
const _hoisted_4 = { class: "sw-app-footer--navs" }
const _hoisted_5 = { class: "d-flex flex-column align-items-center flex-lg-row" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("利用規約")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("投稿ガイドライン")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("プライバシーポリシー")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("運営会社")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("お問い合わせ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("ヘルプ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sw-app-footer--copyright" }, "Copyright©AKATSUKI NEXT Co.,Ltd.", -1))

import {
  computed, withDefaults,
} from 'vue';
import SwBrand from '../molecules/SwBrand.vue';

interface Props {
  color?: 'primary';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwAppFooter',
  props: {
    color: { default: 'primary' }
  },
  setup(__props: any) {

const props = __props as { color: 'primary' }



/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-app-footer': true,
  [`sw-app-footer--${props.color || 'primary'}`]: true,
}));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([_unref(classes), "navbar navbar-light"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "sw-app-footer--brand navbar-brand order-2"
        }, {
          default: _withCtx(() => [
            _createVNode(SwBrand, {
              "site-name": "SPOTWRITE",
              "site-sub-name": "スポットライト",
              "catch-copy": "得意な工程で参加できるWEBTOONとマンガの投稿サイト",
              horizontal: false,
              color: __props.color
            }, null, 8, ["color"])
          ]),
          _: 1
        }),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/terms" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/guidelines" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/privacypolicy" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/company" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/inquiry" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/help" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_12
    ])
  ], 2))
}
}

})